<div fxLayout="column" style="margin-top: 5%;" fxFlex="100">
  <h3>
    Καλώς ορίσατε στις ψηφιακές διαχειριστικές υπηρεσίες <br>
    του ΤΟΕΒ Ταυρωπού!
  </h3>
</div>
